module.exports = __webpack_public_path__ + "media/images/vp/sample.taskimage-9b3edb56391f0154ce4d654c57c3ea26.jpg";